import React from "react";

const CLOUD_PATH = "M6.5 18a3.5 3.5 0 0 1-.6-6.95 4.5 4.5 0 0 1 8.6-2.05A4 4 0 0 1 18.5 16H17";

const ICONS = {
    clear: (
        <>
            <circle cx="12" cy="12" r="4" />
            <path d="M12 3v2M12 19v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M3 12h2M19 12h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4" />
        </>
    ),
    clouds: <path d={CLOUD_PATH} />,
    rain: (
        <>
            <path d={CLOUD_PATH} />
            <path d="M8 20l-1 2M12 20l-1 2M16 20l-1 2" />
        </>
    ),
    snow: (
        <>
            <path d={CLOUD_PATH} />
            <path d="M8 20v3M6.6 21.5h2.8M12 20v3M10.6 21.5h2.8M16 20v3M14.6 21.5h2.8" />
        </>
    ),
    thunderstorm: (
        <>
            <path d={CLOUD_PATH} />
            <path d="M12 19l-2 3.5h3L11 26" />
        </>
    ),
    mist: (
        <>
            <path d="M4 10h13M4 14h16M4 18h11" />
        </>
    ),
    default: <path d={CLOUD_PATH} />,
};

function WeatherIcon({ family }) {
    const glyph = ICONS[family] || ICONS.default;
    return (
        <svg
            className="station__icon"
            viewBox="0 0 24 26"
            width="40"
            height="40"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {glyph}
        </svg>
    );
}

export default WeatherIcon;
